import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

// Public: the token in the URL is the credential, so no session is needed --
// a VIP client who arrived from the emailed link may have no account at all.
const getTableByToken = async (token) => {
  const response = await axios.get(
    routes.getTableByToken(token),
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};
export default getTableByToken;
